import { render, staticRenderFns } from "./CveVulnerabilities.vue?vue&type=template&id=ef19ae1e&scoped=true&"
import script from "./CveVulnerabilities.vue?vue&type=script&lang=js&"
export * from "./CveVulnerabilities.vue?vue&type=script&lang=js&"
import style0 from "./CveVulnerabilities.vue?vue&type=style&index=0&id=ef19ae1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef19ae1e",
  null
  
)

export default component.exports